import React, { ReactElement } from 'react';
import styles from './Tile.module.scss';
import classnames from 'classnames';
import { Title, TitleProps } from '../Title/Title';

interface TileProps {
  className?: string;
  children?: ReactElement;
  title?: TitleProps;
}
export const Tile = ({ className, children, title }: TileProps) => {
  return (
    <div className={classnames(styles.tileContainer, className)}>
      {title && <Title {...title} />}
      {children}
    </div>
  );
};
